/**
 * 지도 컨트롤 — (선택적) 경로 모드 토글 / 현재 위치 / + / − 순서.
 *
 * 경로 모드 토글: 카페가 선택됐을 때만 표시 (showRouteToggle=true).
 *   - routeMode === "walking" → 🚶 아이콘 (도보 기준)
 *   - routeMode === "driving" → 🚗 아이콘 (차량 기준)
 *   클릭하면 모드 전환.
 *
 * bottom 위치는 부모가 결정 (peek 시트 위인지, 풀스크린인지에 따라).
 */
export default function MapControls({
  onZoomIn,
  onZoomOut,
  onLocate,
  bottom = 110,
  routeMode = "walking",
  onToggleRoute,
  showRouteToggle = false,
}) {
  const isWalking = routeMode === "walking";
  return (
    <div className="cf-mapctrls" style={{ bottom }}>
      {showRouteToggle && (
        <button
          className="cf-mapctrl cf-mapctrl--route"
          onClick={onToggleRoute}
          title={
            isWalking
              ? "도보 기준 (클릭하면 차량으로 전환)"
              : "차량 기준 (클릭하면 도보로 전환)"
          }
          aria-label="경로 모드 전환"
        >
          <span className="cf-mapctrl__route-icon">
            {isWalking ? "🚶" : "🚗"}
          </span>
        </button>
      )}

      <button
        className="cf-mapctrl"
        onClick={onLocate}
        title="현 위치"
        aria-label="현 위치"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="3" />
          <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
        </svg>
      </button>
      <button
        className="cf-mapctrl"
        onClick={onZoomIn}
        title="확대"
        aria-label="확대"
      >
        +
      </button>
      <button
        className="cf-mapctrl"
        onClick={onZoomOut}
        title="축소"
        aria-label="축소"
      >
        −
      </button>
    </div>
  );
}
